import React from 'react'
import { translate } from 'react-i18next'
import { useWindowSize } from '../../hooks/useWindowSize'
import {chunk} from 'lodash'
import './index.sass'

const CaseResults = ({ results, t, lng }) => {
	const { width } = useWindowSize()
	const columnNumber = width >= 1366 ? 3 : 2
	const chunkNumber = Math.round(results.audioLangs.length / columnNumber )

	const audioLangs = chunk(results.audioLangs, chunkNumber)
  return (
    <div className="results">
      <p className="subtitle-1 icon icon-results">{t(`cases.${results.title}`)}</p>
      <div className="case-text-wrapper">
        {results.text.map((text, ind) => (
          <p key={`${ind}-results`} className="body-light">
            {t(`cases.${text}`)}
          </p>
        ))}
        <div className="results-langs-wrapper">
				{audioLangs.map((arr, ind) => <div key={ind} className="results-lang-column">{arr.map(lang => (
            <a
              key={lang}
              target="_blank"
              rel="noopener noreferrer"
              href={
                lng === 'en'
                  ? `${window.location.origin}/voices/${lang.toLowerCase().split(' ').join('-')}`
                  : `${window.location.origin}/${lng}/voices/${lang.toLowerCase().split(' ').join('-')}`
              }
            >
              {t(`Language.${lang}`)}
            </a>
          ))}</div>
					
					)}
          {/* {results.audioLangs.map(lang => (
            <a
              key={lang}
              target="_blank"
              rel="noopener noreferrer"
              href={
                lng === 'en'
                  ? `${window.location.origin}/voices/${lang.toLowerCase()}`
                  : `${window.location.origin}/${lng}/voices/${lang.toLowerCase()}`
              }
            >
              {t(`Language.${lang}`)}
            </a>
          ))} */}
        </div>
      </div>
    </div>
  )
}

const CaseChallenge = ({ challenge, t }) => {
  return (
    <div className="challenge">
      <p className="subtitle-1 icon icon-challenge">{t(`cases.${challenge.title}`)}</p>
      <div className="case-text-wrapper">
        {challenge.text.map((text, ind) => (
          <p key={`${ind}-challenge`} className="body-light">
            {t(`cases.${text}`)}
          </p>
        ))}
      </div>
    </div>
  )
}

const CaseSolution = ({ solution, t }) => {
  return (
    <div className="solution">
      <p className="subtitle-1 icon icon-solution">{t(`cases.${solution.title}`)}</p>
      <div className="case-text-wrapper">
        {solution.text.map((text, ind) => (
          <p key={`${ind}-solution`} className="body-light">
            {t(`cases.${text}`)}
          </p>
        ))}
      </div>
    </div>
  )
}

const CaseFlowWithoutI18N = ({ caseTask, t, lng }) => {
  return (
    <div className="case-flow-wrapper">
      <div className="case-flow">
        <CaseChallenge challenge={caseTask.challenge} t={t} />
        <CaseSolution solution={caseTask.solution} t={t} />
        <CaseResults results={caseTask.results} t={t} lng={lng} />
      </div>
    </div>
  )
}

export const CaseFlow = translate('translations')(CaseFlowWithoutI18N)
